import React, { ReactElement, useEffect, useState } from 'react';
import { SimpleUserView } from '../../../types/users';
import { SubmittedField } from '../../../../commonv3/types/lesson_homeworks';
import { UserProfileCell } from '../../../../commonv3/components/atoms/users/UserProfileCell';
import { ExpandableContainer } from '../../../../commonv3/components/atoms/layouts/ExpandableContainer';
import { FieldStateV3, FormContext } from '../../../../commonv3/states/form/FormStateV3';
import './submissionPreview.module.scss';
import { UploadedFilePreview } from '../userFiles/UploadedFilePreview';
import { observer } from 'mobx-react';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { SubmissionFieldType } from '../../../../commonv3/types/course_works';
import Linkify from 'linkifyjs/react';

const FieldSummary = ({ field }: { field: SubmittedField }) => {
    const [state] = useState(new FieldStateV3<any>());
    useEffect(
        () => {
            state._init(field.definition.uid, new FormContext(), field.value);
        },
        [field]
    );
    switch (field.definition.type) {
        case SubmissionFieldType.FILE:
            return <UploadedFilePreview value={field.value as string[]} />;
        case SubmissionFieldType.SINGLE_LINE_TEXT:
            return (
                <div styleName="single-line-preview" id="single-line-preview">
                    <Linkify options={{ className: 'submission-single-line-link' }}>{field.value} </Linkify>
                </div>
            );
        case SubmissionFieldType.GOOGLE_URL:
            return (
                <div styleName="google-url-preview" id="google-url-preview">
                    <Linkify options={{ className: 'google-url-link' }}>{field.value} </Linkify>
                </div>
            );
        case SubmissionFieldType.MULTI_LINE_TEXT:
            return <pre styleName="multi-line-preview">{field.value}</pre>;
    }
};

const FieldSummaryWrapper = ({ field }: { field: SubmittedField }) => {
    return (
        <div styleName="field-summary-wrapper" data-field-uid={field.definition.uid}>
            <div styleName="field-label">{field.definition.label}</div>
            <div styleName="field-body">
                <FieldSummary field={field} />
            </div>
        </div>
    );
};

type Props = {
    user: SimpleUserView;
    submittedFields: SubmittedField[];
    badge?: ReactElement;
};
export const SubmissionPreview = observer(({ user, submittedFields, badge }: Props) => {
    const { isSp } = useViewportState();
    return (
        <div styleName="wrapper" id="submission-preview">
            <div styleName="submitted-user-summary">
                <UserProfileCell user={user} />
            </div>
            <div styleName="body-wrapper">
                <ExpandableContainer collapsibleOffsetHeight={isSp ? 270 : 400}>
                    <div styleName="preview-body">
                        {submittedFields.map((field) => (
                            <FieldSummaryWrapper key={field.definition.uid} field={field} />
                        ))}
                    </div>
                </ExpandableContainer>
                {badge}
            </div>
        </div>
    );
});
